"use client";

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

export function LoadMoreButton({ onClick, isLoading }: LoadMoreButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading}
      className="inline-flex h-11 min-w-36 items-center justify-center gap-2 rounded-xl bg-primary px-6 text-sm font-medium text-white transition-colors hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-wait disabled:bg-white disabled:text-foreground disabled:ring-1 disabled:ring-inset disabled:ring-slate-300"
      aria-live="polite"
    >
      {isLoading ? (
        <>
          <span
            className="h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-primary"
            aria-hidden="true"
          />
          CARREGANDO...
        </>
      ) : (
        "VER MAIS"
      )}
    </button>
  );
}
